import { render, staticRenderFns } from "./OrderView.vue?vue&type=template&id=da7ec63c&"
import script from "./OrderView.vue?vue&type=script&lang=js&"
export * from "./OrderView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports